// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"252":"a0d21c88","2627":"a0d21c88","4474":"a0d21c88","5837":"a0d21c88","6007":"a0d21c88","6581":"a0d21c88","8054":"a0d21c88"}[chunkId] + ".chunk.css";
};